// import { getAuth } from '../auth'; // Giả sử bạn có hàm này để lấy thông tin xác thực

// Định nghĩa kiểu cho dữ liệu xác thực
interface Auth {
    access_token?: string;
}

// Định nghĩa kiểu cho thông điệp WebSocket
interface WSMessage {
    command: string; // Chỉ giữ command vì server dùng command
    data: any;
    type?: string;
    token?: string;
}

// Định nghĩa kiểu cho callback của sự kiện
type EventCallback = (data: any) => void;

const BASE_URL_WS = process.env.REACT_APP_BASE_URL_SOCKET_ENDPOINT || 'ws://localhost:3000';
const auth: Auth = { access_token: 'joi' }; // getAuth();

// Khởi tạo WebSocket
let ws: WebSocket | null = null;

// Lưu trữ các callback cho các sự kiện
const eventListeners = new Map<string, EventCallback[]>();

// Cấu hình reconnect
let reconnectAttempts = 0;
const maxReconnectAttempts = 5;
const reconnectDelay = 3000;

// Hàm gửi lệnh subscribe
const sendSubscribe = (socket: WebSocket) => {
    if (auth && auth.access_token && socket.readyState === WebSocket.OPEN) {
        // const subscribeMessage = {
        //     command: "subcribeLatestTransaction",
        //     data: "eyJwb29sIjoiQzlVMktzazZLS1d2TEVlbzV5VVE3WHU0Nlg3TnplQkp0ZDlQQmZ1WGFVU00ifQ=="
        // };
        // const subscribeMessage2 = {
        //     command: "subcribeLatestTransaction",
        //     data: "eyJwb29sIjoiRzFaV2k4ek1WeUV5ZjNxVEJBWm1FYmVKb0hITk1vNWhaTEsxOWdMUGdTMmYifQ=="
        // };
        // socket.send(JSON.stringify(subscribeMessage));
        // socket.send(JSON.stringify(subscribeMessage2));
        // console.log('Sent subscribe message:', subscribeMessage);
    }
};

// { "command": "subcribeLatestTransaction", "data": "eyJwb29sIjoiQzlVMktzazZLS1d2TEVlbzV5VVE3WHU0Nlg3TnplQkp0ZDlQQmZ1WGFVU00ifQ==" }




// { "command": "subcribeLatestTransaction", "data": "eyJwb29sIjoiRzFaV2k4ek1WeUV5ZjNxVEJBWm1FYmVKb0hITk1vNWhaTEsxOWdMUGdTMmYifQ==" }

// Hàm khởi tạo kết nối
const connect = (): WebSocket => {
    if (ws && ws.readyState === WebSocket.OPEN) {
        return ws;
    }

    ws = new WebSocket(`${BASE_URL_WS}/ws`);

    ws.onopen = () => {
        //console.log('WebSocket connected at', new Date().toISOString());
        reconnectAttempts = 0; // Reset số lần thử khi kết nối thành công
        if (ws) {
            sendSubscribe(ws); // Gửi lệnh subscribe khi kết nối
            // Gửi ping mỗi 8 giây để giữ kết nối
            // const pingInterval = setInterval(() => {
            //     if (ws && ws.readyState === WebSocket.OPEN) {
            //         ws.send(JSON.stringify({ type: 'ping' }));
            //         console.log('Sent ping');
            //     }
            // }, 8000);

            // ws.onclose = () => clearInterval(pingInterval);
        }
    };

    ws.onmessage = (message: MessageEvent) => {
        try {
            // console.log('Received message');
            const msg: WSMessage = JSON.parse(message.data);
            const eventName = msg.command; // Chỉ dùng command
            let eventData = msg.data;

            // Giải mã Base64 nếu data là chuỗi
            if (typeof eventData === 'string') {
                try {
                    eventData = JSON.parse(atob(eventData)); // 'Decoded data'
                } catch (error) {
                    console.error('Error decoding Base64 data:', error);
                }
            }

            // console.log('eventListeners', eventListeners, eventName);

            if (eventName && eventListeners.has(eventName)) {
                // console.log('Processing event:', eventName, eventData);
                eventListeners.get(eventName)!.forEach((callback) => callback(eventData));
            } else {
                // console.log('Unhandled event:', eventName, 'Data:', eventData);
            }
        } catch (error) {
            console.error('Error parsing WebSocket message:', error, message.data);
        }
    };

    ws.onclose = (event) => {
        //  console.log('WebSocket disconnected:', event.code, event.reason, new Date().toISOString());
        ws = null;
        if (reconnectAttempts < maxReconnectAttempts) {
            setTimeout(() => {
                //  console.log(`Reconnecting... Attempt ${reconnectAttempts + 1}`);
                reconnectAttempts++;
                connect();
            }, reconnectDelay * (reconnectAttempts + 1));
        } else {
            console.error('Max reconnect attempts reached');
        }
    };

    ws.onerror = (error: Event) => {
        console.error('WebSocket error:', error, new Date().toISOString());
    };

    return ws;
};

// Hàm ngắt kết nối
const disconnect = (): void => {
    reconnectAttempts = maxReconnectAttempts; // Ngăn reconnect
    if (ws) {
        ws.close();
        ws = null;
        eventListeners.clear();
        // console.log('WebSocket disconnected at', new Date().toISOString());
    }
};

// Hàm emit để gửi sự kiện
const emit = (command: string, data: any): void => {
    if (ws && ws.readyState === WebSocket.OPEN) {
        const message: WSMessage = { command, data };
        ws.send(JSON.stringify(message));
        // console.log('Emitted message:', message);
    } else {
        console.error('WebSocket is not connected');
    }
};

// Hàm on để đăng ký lắng nghe sự kiện
const on = (event: string, callback: EventCallback): void => {
    if (!eventListeners.has(event)) {
        eventListeners.set(event, []);
    }
    eventListeners.get(event)!.push(callback);
    //  console.log('Registered listener for event:', event);
};

// Hàm off để gỡ bỏ callback
const off = (event: string, callback?: EventCallback): void => {
    if (eventListeners.has(event)) {
        if (callback) {
            const callbacks = eventListeners.get(event)!.filter((cb) => cb !== callback);
            eventListeners.set(event, callbacks);
        } else {
            eventListeners.delete(event);
        }
        // console.log('Removed listener for event:', event);
    }
};

// Hàm kiểm tra trạng thái kết nối
const isConnected = (): boolean => {
    return ws !== null && ws.readyState === WebSocket.OPEN;
};

export { connect, disconnect, emit, on, off, isConnected };